import type { IntlShape, MessageDescriptor } from 'react-intl';
import { z } from 'zod';

import { TEAM_TRIAL_UPGRADE_REQUEST_MESSAGE_MAX_LENGTH } from './constants';

export const teamTrialUpgradeRequestMessageTooLongMsg: MessageDescriptor = {
  id: 'bN2kXpQ8vR',
  defaultMessage: 'Message must be {maxLength} characters or less',
  description:
    'Zod validation error when the team trial upgrade request message exceeds the maximum length',
};

export const createTeamTrialUpgradeRequestModalSchema = (
  formatMessage: IntlShape['formatMessage']
) =>
  z.object({
    message: z.string().max(TEAM_TRIAL_UPGRADE_REQUEST_MESSAGE_MAX_LENGTH, {
      message: formatMessage(teamTrialUpgradeRequestMessageTooLongMsg, {
        maxLength: TEAM_TRIAL_UPGRADE_REQUEST_MESSAGE_MAX_LENGTH,
      }),
    }),
  });

export type TeamTrialUpgradeRequestModalFormValues = z.infer<
  ReturnType<typeof createTeamTrialUpgradeRequestModalSchema>
>;
